export var REQUEST_ORIGINS = {
  HOME_PAGE: 'HomePage',
  SELL_FLOW: 'SellFlow',
  LISTING_PAGE: 'ListingPage',
  EVALUATION_FORM: 'EvaluationForm',
  LANDING_PAGE: 'LandingPage'
};
export var REQUEST_ORIGIN = 'request-origin';